import { createApiSlice } from "@common";
import {
  CURD_CUSTOMERS_CURRENCY
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addCustomerCurrency",
    method: "post",
    url: CURD_CUSTOMERS_CURRENCY,
    stateKey: "message",
  },
  {
    name: "getCustomerCurrency",
    method: "get",
    url: CURD_CUSTOMERS_CURRENCY,
    stateKey: "data",
  },
  {
    name: "updateCustomerCurrency",
    method: "put",
    url: CURD_CUSTOMERS_CURRENCY,
    stateKey: "message",
  },
  {
    name: "deleteCustomerCurrency",
    method: "delete",
    url: CURD_CUSTOMERS_CURRENCY,
    stateKey: "message",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    someCustomAction: (state, action) => {
      // Custom reducer logic
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "customerCurrency",
  apiConfig,
  customReducers,
);
const customerCurrencySlice = slice;
// Export the slice's reducer
export default customerCurrencySlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
  addCustomerCurrency,
  getCustomerCurrency,
  updateCustomerCurrency,
  deleteCustomerCurrency
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
  actions;
